import React, { useCallback } from 'react';
import Space from 'Modules/Space';
import toast from 'react-hot-toast';
import WarningIcon from 'Assets/images/commons/warning.svg';
import { useDispatch, useSelector } from 'react-redux';

const useIsHealthSummaryUploading = () => {
  const healthSummaryFiles = useSelector(state => state.files.healthSummaryFileUpload);

  const isHealthSummaryUploading = healthSummaryFiles.find(file => file.uploadStatus === 'loading');

  const dispatch = useDispatch();

  const resetHealthSummaryUpload = useCallback(() => {
    dispatch({
      type: 'HEALTH_SUMMARY_FILE_UPLOAD_REQUESTED',
      payload: [],
    });
  }, [dispatch]);

  const showAlert = useCallback(() => {
    toast(
      <Space size={16} direction="horizontal" alignItems="start">
        <img style={{ width: 24 }} src={WarningIcon} alt="warning" />
        <Space size={8}>
          <h4 style={{ marginBottom: 0 }}>Upload in progress</h4>
          <div>Please wait until the attachment upload is complete.</div>
        </Space>
      </Space>,
      {
        position: 'top-right',
        duration: 3000,
      },
    );
  }, []);

  return { isHealthSummaryUploading, resetHealthSummaryUpload, showAlert };
};

export default useIsHealthSummaryUploading;
